module.exports = __webpack_public_path__ + "media/images/homepage_background-07a7afa605cf53c6f6cafb4826d72dae.jpg";